import type { FC } from "react";
import { useMemo } from "react";
import classes from "./SwiperComp.module.scss";
import "./swiper.scss";

import { Swiper, SwiperSlide } from "swiper/react";
import { v4 as uuidv4 } from "uuid";
import clsx from "clsx";

import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/navigation";

import { EffectCoverflow, Navigation } from "swiper";
import { Alert } from "../Alert/Alert";

export interface SwiperCompProps {
	className?: string;
}

export interface SwiperCompComponent extends FC<SwiperCompProps> {}

export interface InfoType {
	image: string;
	name: string;
	stage: string;
}

export const SwiperComp: SwiperCompComponent = ({ className }) => {
	const info: InfoType[] = [
		{ image: "images/1.png", name: "Jenny Wilson", stage: "Co-Founder, CEO" },
		{ image: "images/2.png", name: "Jenny Wilson", stage: "Co-Founder, CEO" },
		{ image: "images/3.png", name: "Jenny Wilson", stage: "Co-Founder, CEO" },
		{ image: "images/4.png", name: "Jenny Wilson", stage: "Co-Founder, CEO" },
		{ image: "images/5.png", name: "Jenny Wilson", stage: "Co-Founder, CEO" },
	];

	const wrapperClassName = useMemo(
		() =>
			clsx(
				classes.wrapper,

				{},
				className
			),
		[className]
	);

	const duplicatedImages = [...info, ...info];

	return (
		<div className={wrapperClassName}>
			<Swiper
				freeMode={true}
				centeredSlides={true}
				slidesPerView={3}
				spaceBetween={-50}
				loop={true}
				effect={"coverflow"}
				coverflowEffect={{
					rotate: 0,
					stretch: 0,
					depth: 500,
					modifier: 1,
					slideShadows: false,
				}}
				breakpoints={{
					825: {
						slidesPerView: 3,
						spaceBetween: -500,
					},
				}}
				navigation={true}
				modules={[EffectCoverflow, Navigation]}
				className={classes.mySwiper}
			>
				{duplicatedImages.map(({ image, name, stage }) => (
					<SwiperSlide key={uuidv4()}>
						<div className="content">
							<Alert className="alert" title={name} stage={stage} />
							<img className={classes.image} src={image} alt={image} />
						</div>
					</SwiperSlide>
				))}
			</Swiper>
		</div>
	);
};
